var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEnergia(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15.568 9.16",
    height: 34.619,
    width: 58.84,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f5a100",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.35277775
    },
    d: "M106.924 152.413h-5.333v-1.687h5.333z",
    transform: "translate(-98.05 -144.254)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3d3d3c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0h.988a.27.27 0 0 0 .271-.271V-.43a.28.28 0 0 0-.071-.184c-.574-.638-1.212-.957-1.917-.957-.322 0-.62.065-.893.198a2.187 2.187 0 0 0-.711.539c-.2.229-.356.497-.471.808a2.864 2.864 0 0 0-.171.999c0 .342.052.667.156.973.102.306.249.577.437.813.19.235.417.42.685.555.267.135.561.204.882.204.406 0 .782-.1 1.127-.3.268-.155.49-.363.666-.624a.268.268 0 0 1 .381-.066l.67.495c.11.081.147.234.075.35-.25.409-.595.742-1.033 1-.509.299-1.121.448-1.833.448a3.52 3.52 0 0 1-1.465-.304 3.769 3.769 0 0 1-1.17-.823 3.853 3.853 0 0 1-1.064-2.678c0-.549.095-1.06.283-1.535.19-.473.446-.885.77-1.234.324-.35.706-.624 1.144-.823a3.36 3.36 0 0 1 1.406-.299c.626 0 1.192.183 1.697.549.175.126.42-.01.42-.226a.27.27 0 0 1 .269-.27h.679c.149 0 .271.121.271.27V.81c0 .149-.122.27-.271.27H0A.271.271 0 0 1-.271.81V.271C-.271.121-.149 0 0 0",
    transform: "matrix(.35278 0 0 -.35278 5.582 2.7)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3d3d3c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0c-.149 0-.305-.03-.465-.091a1.971 1.971 0 0 1-.476-.262 2.742 2.742 0 0 1-.438-.4 2.522 2.522 0 0 1-.353-.519v.927a.27.27 0 0 1-.27.271h-.774a.27.27 0 0 1-.271-.271v-5.061a.27.27 0 0 1 .271-.271h.891a.27.27 0 0 1 .271.271v3.051c0 .043.01.089.03.129.151.29.388.51.707.66.273.129.577.208.91.238a.273.273 0 0 1 .255.268v1.049A.575.575 0 0 1 .176 0Z",
    transform: "matrix(.35278 0 0 -.35278 7.927 1.694)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3d3d3c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0a.273.273 0 0 0-.26.351 1.543 1.543 0 0 0 .399.654c.128.121.276.216.443.283.168.067.348.102.54.102A1.418 1.418 0 0 0 2.527.338.271.271 0 0 0 2.264 0Zm3.287 1.561a2.803 2.803 0 0 1-.92.63 3.008 3.008 0 0 1-1.223.236c-.457 0-.869-.078-1.235-.236A2.74 2.74 0 0 1-1.614.625a3.108 3.108 0 0 1-.203-1.127c0-.386.069-.752.208-1.102.138-.349.337-.656.593-.919.256-.264.567-.472.93-.625.363-.154.77-.23 1.219-.23.627 0 1.167.137 1.619.411.334.202.602.447.802.733a.273.273 0 0 1-.154.416l-.681.189a.263.263 0 0 1-.292-.106 1.158 1.158 0 0 0-.434-.387 1.647 1.647 0 0 0-.806-.208 1.5 1.5 0 0 0-.536.096 1.437 1.437 0 0 0-.791.716 1.457 1.457 0 0 0-.091.234.272.272 0 0 0 .257.354H4.03c.014.057.023.128.027.213.004.086.005.175.005.268 0 .378-.066.741-.198 1.091a2.695 2.695 0 0 1-.577.919",
    transform: "matrix(.35278 0 0 -.35278 8.73 2.542)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3d3d3c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0a.273.273 0 0 0-.261.351 1.543 1.543 0 0 0 .399.654c.128.121.276.216.443.283.168.067.348.102.54.102A1.416 1.416 0 0 0 2.526.338.271.271 0 0 0 2.263 0Zm3.286 1.561a2.809 2.809 0 0 1-.919.63c-.36.158-.768.236-1.224.236-.456 0-.868-.078-1.235-.236A2.74 2.74 0 0 1-1.615.625a3.108 3.108 0 0 1-.203-1.127c0-.386.069-.752.208-1.102.139-.349.337-.656.593-.919.257-.264.567-.472.93-.625.364-.154.77-.23 1.219-.23.627 0 1.167.137 1.62.411.334.202.601.447.801.733a.273.273 0 0 1-.153.416l-.682.189a.263.263 0 0 1-.292-.106 1.163 1.163 0 0 0-.433-.387 1.653 1.653 0 0 0-.807-.208 1.49 1.49 0 0 0-.995.374 1.48 1.48 0 0 0-.423.672.273.273 0 0 0 .258.354h4.003c.014.057.023.128.027.213.004.086.006.175.006.268 0 .378-.067.741-.199 1.091a2.695 2.695 0 0 1-.577.919",
    transform: "matrix(.35278 0 0 -.35278 10.99 2.542)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3d3d3c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0a1.39 1.39 0 0 1-.513.502c-.221.128-.507.192-.855.192-.492 0-.934-.099-1.326-.298a2.34 2.34 0 0 1-.455-.303.268.268 0 0 0-.443.205v.03a.27.27 0 0 1-.27.271h-.753a.27.27 0 0 1-.271-.271v-5.061a.27.27 0 0 1 .271-.271h.891a.27.27 0 0 1 .271.271v2.954a.32.32 0 0 0 .014.092c.05.153.124.294.221.425.107.143.227.266.359.368.131.104.272.184.421.241.15.057.296.086.439.086a.774.774 0 0 0 .652-.31c.157-.207.236-.535.236-.984v-2.872a.27.27 0 0 1 .269-.271h.893a.27.27 0 0 1 .269.271v3.225c0 .271-.022.538-.069.802A2.1 2.1 0 0 1 0 0",
    transform: "matrix(.35278 0 0 -.35278 14.455 1.931)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f5a100",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0a.894.894 0 0 1-.619-.237.808.808 0 0 1-.27-.609c0-.235.093-.44.276-.609a.88.88 0 0 1 .616-.248c.228 0 .431.077.601.23a.768.768 0 0 1 .266.579.84.84 0 0 1-.278.659A.874.874 0 0 1 0 0",
    transform: "matrix(.35278 0 0 -.35278 2.362 4.437)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3d3d3c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0v3.686a.27.27 0 0 1-.271.27h-.891a.27.27 0 0 1-.27-.27V.549c0-.044-.01-.09-.031-.13a1.763 1.763 0 0 0-.605-.702 1.477 1.477 0 0 0-.807-.251c-.62 0-.931.43-.931 1.294v2.926a.27.27 0 0 1-.27.27h-.892a.27.27 0 0 1-.27-.27V.449c0-.726.15-1.275.449-1.646.3-.37.738-.556 1.314-.556.471 0 .903.097 1.294.289.393.193.713.481.962.865l.032-.449a.7.7 0 0 1 .284-.486c.161-.117.369-.176.626-.176a3.137 3.137 0 0 1 .62.064v.988c0 .109-.056.221-.157.262A.267.267 0 0 0 .08-.32C.027-.256 0-.149 0 0",
    transform: "matrix(.35278 0 0 -.35278 5.916 5.466)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3d3d3c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0h.892a.27.27 0 0 1 .27.271v5.061a.271.271 0 0 1-.27.271H0a.272.272 0 0 1-.271-.271V.271C-.271.121-.149 0 0 0",
    transform: "matrix(.35278 0 0 -.35278 6.514 6.047)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3d3d3c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m0 0 2.669 3.201c.04.049.062.111.062.173v.509a.27.27 0 0 1-.27.27h-3.96a.271.271 0 0 1-.271-.27v-.464c0-.149.122-.271.271-.271H.645a.27.27 0 0 0 .207-.444L-1.835-.497a.274.274 0 0 1-.062-.174v-.508a.27.27 0 0 1 .269-.27h4.143a.27.27 0 0 1 .269.27v.465a.27.27 0 0 1-.269.271H.208A.27.27 0 0 0 0 0",
    transform: "matrix(.35278 0 0 -.35278 7.917 5.536)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f5a100",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0c-.538.452-1.189.682-1.936.682-.72 0-1.309-.225-1.751-.666a2.185 2.185 0 0 1-.664-1.587c0-.541.132-.97.391-1.275.269-.314.59-.474.955-.474.247 0 .466.058.651.174a.657.657 0 0 1 .327.575c0 .114-.041.28-.234.422-.196.143-.402.187-.61.113-.025-.009-.127-.053-.232.117a.811.811 0 0 0-.109.438c0 .33.11.591.339.801.233.215.552.319.974.319a.923.923 0 0 0 .772-.374c.211-.269.314-.565.314-.906 0-.294-.061-.59-.18-.88-.117-.289-.408-.654-.863-1.085-.493-.463-.813-.844-.981-1.166a2.136 2.136 0 0 1-.257-.982c0-.429.044-.574.083-.653.078-.161.229-.249.423-.249.16 0 .53.073.53.753 0 .178.07.385.204.614.141.239.414.519.809.832.423.334.755.615.986.835.245.232.454.507.622.816.177.323.267.682.267 1.068C.83-1.047.551-.462 0 0",
    transform: "matrix(.35278 0 0 -.35278 3.26 1.91)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0v3.215h1.3v-.298H.33v-1.14h.827v-.294H.33V.299h.983V0Z",
    transform: "matrix(.35278 0 0 -.35278 3.833 7.866)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0v3.215h.335L1.276.776v2.439h.308V0h-.316l-.96 2.485V0Z",
    transform: "matrix(.35278 0 0 -.35278 4.539 7.866)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0v3.215h1.3v-.298H.33v-1.14h.827v-.294H.33V.299h.983V0Z",
    transform: "matrix(.35278 0 0 -.35278 5.38 7.866)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0h.428c.307 0 .44.128.44.464v.34c0 .335-.133.464-.44.464H0Zm.965-1.649L.474-.294H0v-1.355h-.33v3.214h.775c.488 0 .754-.219.754-.679v-.5c0-.336-.142-.542-.409-.63l.52-1.405z",
    transform: "matrix(.35278 0 0 -.35278 6.201 7.284)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0c0-.469-.267-.68-.753-.68H-.79c-.486 0-.753.206-.753.68v1.929c0 .45.267.679.753.679h.037c.486 0 .753-.229.753-.679v-.432h-.331v.349c0 .336-.133.464-.44.464-.308 0-.442-.128-.442-.464V.082c0-.335.134-.464.442-.464.307 0 .44.129.44.464v.593H-.79v.294H0Z",
    transform: "matrix(.35278 0 0 -.35278 7.424 7.639)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.35277775
    },
    d: "M105.75 150.985h.117v1.134h-.116z",
    transform: "translate(-98.05 -144.254)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m0 0-.335 1.672L-.671 0Zm.055-.289h-.781l-.161-.795h-.321l.68 3.215h.395l.689-3.215h-.34z",
    transform: "matrix(.35278 0 0 -.35278 8.463 7.483)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3d3d3c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0a3.753 3.753 0 0 1-1.12 2.478c-.222.22-.46.406-.709.563l-.179-.144c-.451-.356-.619-.582-.68-.683a1.212 1.212 0 0 1-.11-.238c.248-.119.481-.273.687-.48.422-.422.663-.936.715-1.526a2.412 2.412 0 0 0-.292-1.383l-.418.419a.276.276 0 0 1-.388 0l-.604-.604a.275.275 0 0 1 0-.387l.418-.417a2.36 2.36 0 0 0-1.382-.284 2.345 2.345 0 0 0-1.525.705 2.41 2.41 0 0 0-.716 1.744c0 .675.241 1.258.715 1.733.206.207.432.358.67.476l-.001.047c0 .41.107.823.317 1.226.055.106.122.214.2.325a3.683 3.683 0 0 1-2.166-1.084A3.721 3.721 0 0 1-7.699-.235c-.011-1.055.366-1.972 1.121-2.727.692-.692 1.526-1.069 2.478-1.12a3.732 3.732 0 0 1 2.246.55.273.273 0 0 0 .338-.034l.39-.391a.276.276 0 0 1 .39.002l.593.601a.274.274 0 0 1-.001.387l-.38.38a.275.275 0 0 0-.034.34C-.143-1.584.044-.831 0 0",
    transform: "matrix(.35278 0 0 -.35278 3.716 4.651)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f5a100",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0c.075 0 .151.013.227.038L3.08.989a.713.713 0 1 1-.451 1.354l-2.855-.952A.714.714 0 0 1 0 0",
    transform: "matrix(.35278 0 0 -.35278 10.69 4.936)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f5a100",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0c.075 0 .151.012.227.036l4.281 1.428a.712.712 0 0 1 .45.902.71.71 0 0 1-.902.451L-.226 1.391A.716.716 0 0 1-.677.487.715.715 0 0 1 0 0",
    transform: "matrix(.35278 0 0 -.35278 10.69 5.69)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f5a100",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M0 0a2.136 2.136 0 0 1-2.126-2.007h-.025c.011.123.013.533-.003.615-.08.404-.254.771-.497 1.079L.227.646A.714.714 0 0 1-.226 2L-4.507.573A.713.713 0 0 1-4.42-.804c.573 0 .759-.769.855-1.203h-.002a.712.712 0 0 1-.714-.713v-.714c0-.394.319-.713.714-.713v-.713c0-.395.319-.714.713-.714h1.427c.395 0 .714.319.714.714v.713c.395 0 .713.319.713.713v.714a.71.71 0 0 1-.687.708c.062.33.339.585.687.585A.714.714 0 1 1 0 0",
    transform: "matrix(.35278 0 0 -.35278 12.2 6.158)"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnergia);
export default __webpack_public_path__ + "static/media/energia.8ed9631f3fb3247720c693ec1838bf9b.svg";
export { ForwardRef as ReactComponent };